import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectorOption } from 'src/app/interfaces/form-and-field.interface';
import { PaginationResolver } from 'src/app/interfaces/pagination.interface';
import { SearchParameters } from 'src/app/interfaces/search.interface';

@Component({
  selector: 'app-shared-search',
  templateUrl: './shared-search.component.html',
  styleUrls: ['./shared-search.component.scss'],
})
export class SharedSearchComponent {
  // Shared search component, allows overriding the search results html
  @Input({ required: true }) public resolver: PaginationResolver;
  @Input({ required: true }) public searchOptions: SelectorOption[];

  @Output() public search: EventEmitter<SearchParameters> = new EventEmitter<SearchParameters>();

  public onSearch(event: SearchParameters): void {
    this.search.emit(event);
  }
}
